import BoxOutline from 'components/Icons/BoxOutline';
import DropboxOutline from 'components/Icons/DropboxOutline';
import EgnyteOutline from 'components/Icons/EgnyteOutline';
import GoogleDriveOutline from 'components/Icons/GoogleDriveOutline';
import OneDriveOutline from 'components/Icons/OneDriveOutline';
import SharePointOutline from 'components/Icons/SharePointOutline';
import { accountNames, integrationsPageText } from 'copy/integrationsPage';
import boxModalBanner from 'images/box-connection.jpg';
import box from 'images/box.svg';
import dropboxModalBanner from 'images/dropbox-connection.jpg';
import dropbox from 'images/dropbox.svg';
import egnyteModalBanner from 'images/egnyte-connection.jpg';
import egnyte from 'images/egnyte.svg';
import googleDriveModalBanner from 'images/google-drive-connection.jpg';
import googleDrive from 'images/google-drive.svg';
import onedriveModalBanner from 'images/onedrive-connection.jpg';
import onedrive from 'images/onedrive.svg';
import sharepointModalBanner from 'images/sharepoint-connection.png';
import sharepoint from 'images/sharepoint.svg';

export const getAccountName = (providerType: string): string => {
  const { short } = accountNames;
  switch (providerType) {
    case 'studio':
      return short.studio;
    case 'sharepoint':
      return integrationsPageText.sharepoint.title;
    case 'box':
      return integrationsPageText.box.title;
    case 'dropbox':
      return integrationsPageText.dropbox.title;
    case 'googledrive':
      return integrationsPageText.googledrive.title;
    case 'egnyte':
      return integrationsPageText.egnyte.title;
    case 'onedrive':
      return integrationsPageText.onedrive.title;
    default:
      return 'Connection';
  }
};

export const getAccountShortName = (providerType: string): string => {
  const { short } = accountNames;

  switch (providerType) {
    case 'studio':
      return short.studio;
    case 'sharepoint':
      return short.sharepoint;
    case 'box':
      return short.box;
    case 'dropbox':
      return short.dropbox;
    case 'googledrive':
      return short.googledrive;
    case 'egnyte':
      return short.egnyte;
    case 'onedrive':
      return short.onedrive;
    default:
      return 'Account';
  }
};

export const getIntegrationIcon = (providerType: string): string => {
  switch (providerType) {
    case 'sharepoint':
      return sharepoint;
    case 'box':
      return box;
    case 'dropbox':
      return dropbox;
    case 'googledrive':
      return googleDrive;
    case 'egnyte':
      return egnyte;
    case 'onedrive':
      return onedrive;
    default:
      return sharepoint;
  }
};

export const getIntegrationOutlineIcon = (
  providerType: string
): React.FC<{ className?: string; height?: string; width?: string }> => {
  switch (providerType) {
    case 'sharepoint':
      return SharePointOutline;
    case 'box':
      return BoxOutline;
    case 'dropbox':
      return DropboxOutline;
    case 'googledrive':
      return GoogleDriveOutline;
    case 'egnyte':
      return EgnyteOutline;
    case 'onedrive':
      return OneDriveOutline;
    default:
      return SharePointOutline;
  }
};

export const getIntegrationBanner = (providerType: string): string => {
  switch (providerType) {
    case 'sharepoint':
      return sharepointModalBanner;
    case 'box':
      return boxModalBanner;
    case 'dropbox':
      return dropboxModalBanner;
    case 'googledrive':
      return googleDriveModalBanner;
    case 'egnyte':
      return egnyteModalBanner;
    case 'onedrive':
      return onedriveModalBanner;
    default:
      return sharepoint;
  }
};

export const getIntegrationTextContent = (
  providerType: string
): IntegrationTextContent => {
  switch (providerType) {
    case 'sharepoint':
      return integrationsPageText.sharepoint;
    case 'box':
      return integrationsPageText.box;
    case 'dropbox':
      return integrationsPageText.dropbox;
    case 'googledrive':
      return integrationsPageText.googledrive;
    case 'egnyte':
      return integrationsPageText.egnyte;
    case 'onedrive':
      return integrationsPageText.onedrive;
    default:
      return integrationsPageText.sharepoint;
  }
};

export type IntegrationTextContent = {
  authUrl: string;
  title: string;
  subtitle?: string;
  text?: string;
  learnMore: {
    text?: string;
    textLink: string;
    link: string;
  };
};
